import { render, staticRenderFns } from "./Subscribers.vue?vue&type=template&id=64af4590&"
import script from "./Subscribers.vue?vue&type=script&lang=js&"
export * from "./Subscribers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports